// @ts-ignore
import Colcade from "colcade";

type MasonryOptions = {
  columns: string
  items: string
  // fills columns top-to-bottom in source order first, then moves to the next column,
  // instead of Colcade's default greedy shortest-column placement
  verticalOrdering?: boolean
}

function layoutMasonry(container: Element, options: MasonryOptions): void {
  if (!options.verticalOrdering) {
    new Colcade(container, { columns: options.columns, items: options.items });
    return;
  }

  const columns = Array.from(container.querySelectorAll<HTMLElement>(options.columns));
  const items = Array.from(container.querySelectorAll<HTMLElement>(options.items));
  if (columns.length === 0 || items.length === 0) return;

  // Allow editor-defined breaks in the mega-menu
  if (items.some(item => item.dataset["megamenuColumnBreak"] === '1')) {
    let columnIndex = 0;
    let currentColumnHasItems = false;
    items.forEach((item) => {
      if (item.dataset["megamenuColumnBreak"] === '1' && currentColumnHasItems && columnIndex < columns.length - 1) {
        columnIndex++;
        currentColumnHasItems = false;
      }
      columns[columnIndex]!.appendChild(item);
      currentColumnHasItems = true;
    });
    return;
  }

  const chunkSize = Math.ceil(items.length / columns.length);
  items.forEach((item, index) => {
    columns[Math.floor(index / chunkSize)]!.appendChild(item);
  });
}

function getTransitionScrollY(headerWrapper: Element): number {
  const heroImageRect = document.querySelector('.hero-section-image__text-content')?.getBoundingClientRect().top;
  const headerWrapperRect = headerWrapper.getBoundingClientRect().height;
  let transitionScrollY = window.innerHeight * 0.1;
  if (heroImageRect && headerWrapperRect) {
    const box = heroImageRect - headerWrapperRect;
    // box > 0: must not touch the header --> glass/blur effect
    // box < transitionScrollY: transition must toggle earlier
    if (box > 0 && box < transitionScrollY) {
      transitionScrollY = box;
    }
  }
  return transitionScrollY;
}


function handleScrollTransition(headerWrapper: Element | null) {
  if (!headerWrapper) return;
  if (headerWrapper.classList.contains('header-wrapper--no-transparent')) return;

  const transitionScrollY = getTransitionScrollY(headerWrapper);

  // replace all scroll function by using onscroll instead of addEventListener
  window.onscroll = function() {
    if (headerWrapper.classList.contains('header-wrapper--no-transparent')) return;

    if (window.scrollY > transitionScrollY) {
      headerWrapper.classList.remove('header-wrapper--transparent')
    } else {
      headerWrapper.classList.add('header-wrapper--transparent')
    }
  }
}


function InitAestheticHeader() {
  const headerWrapper = document.querySelector('.header-wrapper')

  if (headerWrapper) {
    headerWrapper.addEventListener('mouseover', () => {
      if (headerWrapper.classList.contains('header-wrapper--no-transparent')) return;
      const root = document.documentElement
      if (!root.classList.contains('header-open')) {
        root.classList.add('header-open')
      }
      headerWrapper.classList.remove('header-wrapper--transparent')
    })

    headerWrapper.addEventListener('mouseleave', () => {
      if (headerWrapper.classList.contains('header-wrapper--no-transparent')) return;
      const root = document.documentElement
      root.classList.remove('header-open')

      const transitionScrollY = getTransitionScrollY(headerWrapper)
      if (window.scrollY > transitionScrollY) {
        headerWrapper.classList.remove('header-wrapper--transparent')
      } else {
        headerWrapper.classList.add('header-wrapper--transparent')
      }
    })
  }

  // If the pointer is already over the header when JS initializes (e.g. user hovered
  // before the module script finished downloading), correct the state immediately.
  // Fix for PALKLI-2255
  if (headerWrapper && !headerWrapper.classList.contains('header-wrapper--no-transparent') && headerWrapper.matches(':hover')) {
    document.documentElement.classList.add('header-open')
    headerWrapper.classList.remove('header-wrapper--transparent')
  }


  handleScrollTransition(headerWrapper);

  window.addEventListener('load', function () {
    handleScrollTransition(headerWrapper);
  });

  window.addEventListener('resize', function () {
    handleScrollTransition(headerWrapper);
  });

  window.addEventListener('orientationchange', function () {
    handleScrollTransition(headerWrapper);
  });


  var transparencyColor = '';
  ['pampas', 'main', 'black'].forEach(color => {
    if (headerWrapper?.classList.contains(color)) transparencyColor = color
  })

  const headerBright = () => {
    if (!!headerWrapper) {
      headerWrapper.classList.remove('header-wrapper--megamenu')

      // Change logo color
      headerWrapper.querySelector('.header-logo-pampas')?.classList.add('display-none')
      headerWrapper.querySelector('.header-logo-main')?.classList.remove('display-none')

      // Change button color
      const headerButtonTrans = headerWrapper.querySelector('.header-button-transparent')
      headerButtonTrans?.classList.add(transparencyColor)
      headerButtonTrans?.classList.remove('pampas')

      const headerButton = headerWrapper.querySelector('.header-button')
      headerButton?.classList.add('main')
      headerButton?.classList.remove('pampas')
    }
  }

  const headerDark = () => {
    if (!!headerWrapper) {
      headerWrapper.classList.add('header-wrapper--megamenu')
      const headermenuHeader = document.querySelector('.headermenu-header')
      // do not toggle the bg canvas for mobile menu
      // equals @include breakpoint('tablet')
      if (window.matchMedia('(min-width: 768px)').matches) {
        headermenuHeader?.classList.add('display-none')
      } else {
        // set new div child element to show megamenu category
        const currentMegamenuCategory = document.querySelector('.megamenu--open .megamenu__category-current')
        if (currentMegamenuCategory) headermenuHeader?.appendChild(currentMegamenuCategory.cloneNode(true))
      }

      // Change logo color
      headerWrapper.querySelector('.header-logo-main')?.classList.add('display-none')
      headerWrapper.querySelector('.header-logo-pampas')?.classList.remove('display-none')

      // Change button color
      const headerButtonTrans = headerWrapper.querySelector('.header-button-transparent')
      headerButtonTrans?.classList.add('pampas')
      headerButtonTrans?.classList.remove(transparencyColor)

      const headerButton = headerWrapper.querySelector('.header-button')
      headerButton?.classList.add('pampas')
      headerButton?.classList.remove('main')

      headerWrapper.classList.remove('header-wrapper--header-menu')
    }
  }

  const handleHeaderColor = () => {
    const megamenu = document.querySelector('.megamenu')
    if (megamenu && megamenu.classList.contains('megamenu--open')) {
      headerDark()
    } else {
      headerBright()
    }
  }

  document.querySelector('.headerlink--has_children')?.addEventListener('click', (e: Event) => {
    e.preventDefault()
    const currentTarget = e.currentTarget as HTMLElement
    const megamenu = currentTarget.nextElementSibling
    megamenu?.classList.toggle('megamenu--closed')
    megamenu?.classList.toggle('megamenu--open')

    handleHeaderColor()
  })

  /**
   *  Open Menu if clicked on the burger icon
   */

  const updateHeadermenuButtonLabel = (button: HTMLElement | null | undefined) => {
    if (!button) return;
    const label = button.classList.contains('headermenu-button--open')
      ? button.dataset['labelClose']
      : button.dataset['labelOpen'];
    if (label) button.setAttribute('aria-label', label);
  }

  document.querySelector('.headermenu-mobile__header--close')?.addEventListener('click', (e: Event) => {
    const root = document.documentElement
    root.classList.remove('header-open')

    const headermenuHeader = document.querySelector('.headermenu-header')
    headermenuHeader?.classList.add('display-none')
    // remove div child element to hide megamenu category
    headermenuHeader?.replaceChildren();

    const headermenuMain = document.querySelector('.headermenu-main')
    headermenuMain?.classList.toggle('headermenu-main--open')
    headermenuMain?.classList.toggle('headermenu-main--closed')

    const headerButton = document.querySelector<HTMLElement>('.headermenu-button')
    headerButton?.classList.remove('headermenu-button--open')
    if (!headerButton?.classList.contains('headermenu-button--closed')) {
      headerButton?.classList.add('headermenu-button--closed')
    }
    updateHeadermenuButtonLabel(headerButton)
  })

  document.querySelector('.headermenu-button')?.addEventListener('click', (e: Event) => {
    const root = document.documentElement
    root.classList.toggle('header-open')
    const currentTarget = e.currentTarget as HTMLElement

    currentTarget?.classList.toggle('headermenu-button--open')
    currentTarget?.classList.toggle('headermenu-button--closed')
    updateHeadermenuButtonLabel(currentTarget)

    // diplays the section of the headermenu in the initial header (keeping the same button element)
    const headermenuHeader = document.querySelector('.headermenu-header')
    if (currentTarget.classList.contains('headermenu-button--closed')) {
      currentTarget.classList.add(transparencyColor);
      headermenuHeader?.classList.add('display-none')
      // remove div child element to hide megamenu category
      headermenuHeader?.replaceChildren();
    } else {
      headermenuHeader?.classList.toggle('display-none')
    }

    if (headerWrapper) {
      if (currentTarget.classList.contains('headermenu-button--open')) {
        currentTarget.classList.remove(transparencyColor);
        headerWrapper.classList.add('header-wrapper--header-menu')
      } else {
        headerWrapper.classList.remove('header-wrapper--header-menu')
      }
    }

    const headermenuMain = document.querySelector('.headermenu-main')
    headermenuMain?.classList.toggle('headermenu-main--open')
    headermenuMain?.classList.toggle('headermenu-main--closed')

    if (root?.classList.contains('header-open')) {
      document.querySelectorAll('.megamenu').forEach(megamenu => {
        megamenu.classList.remove('megamenu--open')
        megamenu.classList.add('megamenu--closed')
      })
    }
    headerBright()

    document.querySelectorAll('.header__center-menu__list--item').forEach((el) => {
      const root = document.documentElement
      el.addEventListener('mouseenter', () => {
        root.classList.add('header-open');
      })
      el.addEventListener('mouseleave', () => {
        root.classList.remove('header-open');
      })
    })
  })

  // NEW MOBILE MENU
  const mobileNavigation = document.querySelector('.headermenu-mobile__navigation')
  if (!mobileNavigation) return;

  mobileNavigation.addEventListener('click', (e) => {
    if (!(e.target instanceof Element)) return;
    const li: HTMLElement | null = e.target?.closest('[data-submenu]')
    const panel: HTMLElement | null = e.target?.closest('.headermenu-mobile__menu-panel')

    if (panel && li && mobileNavigation.contains(panel)) {
      const newPanel = document.getElementById(`menu-panel-${li.dataset["submenu"]}`)
      if (newPanel) {
        panel.classList.remove('is-active')
        newPanel.classList.add('is-active')
      }
    }

    const backButton = e.target?.closest('.headermenu-mobile__menu-panel--back__arrow')
    if (backButton) {
      const currentPanel: HTMLElement | null = backButton.closest('.headermenu-mobile__menu-panel');
      const parentId = currentPanel?.dataset["parentId"];
      const parentPanel = document.getElementById(`menu-panel-${parentId}`);
      if (currentPanel && parentPanel) {
        currentPanel.classList.remove('is-active');
        parentPanel.classList.add('is-active');
      }
    }
  })

  const navigationColumns = document.querySelectorAll('.header__center-menu__children--content')

  navigationColumns.forEach((navigationColumn) => {
    layoutMasonry(navigationColumn, {
      columns: '.header__center-menu__masonry-col',
      items: '.header__center-menu__masonry-col__item',
      verticalOrdering: true,
    });
  });

  // SEARCH OVERLAY
    const searchButton = document.querySelector('.searchbar-button') as HTMLButtonElement | null
    const overlay = document.querySelector('.header-overlay') as HTMLDialogElement | null
    const searchBar = document.querySelector('.header-overlay__search-bar') as HTMLInputElement | null
    const closeButton = document.querySelector('.header-overlay__close') as HTMLButtonElement | null

  const openOverlay = () => {
    if (!overlay) return
    overlay.classList.add('is-open')
    overlay.setAttribute('aria-hidden', 'false')
      searchBar?.focus()
    document.body.classList.add('lock-scroll')
  }

  const closeOverlay = () => {
    if (!overlay) return
    overlay.classList.remove('is-open')
    overlay.setAttribute('aria-hidden', 'true')
      searchBar?.blur()
    document.body.classList.remove('lock-scroll')
  }

    searchButton?.addEventListener('click', (e: Event) => {
    e.preventDefault()
    openOverlay()
  })

    closeButton?.addEventListener('click', (e: Event) => {
    e.preventDefault()
    closeOverlay()
  })

  document.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Escape' && overlay?.classList.contains('is-open')) {
      closeOverlay()
    }
  })
}

InitAestheticHeader()
